// extracted by mini-css-extract-plugin
export default {"gallery":"c-q_fN","gallery__header":"c-q_fO","gallery__thumbs":"c-q_fP"};